export default __webpack_public_path__ + "static/media/DudeArrow.09b2bae1.svg";